<script setup>
import { computed } from 'vue'

const props = defineProps({
	article: {
		type: Object,
		required: true,
	},
	config: {
		type: Object,
		required: true,
	},
})

const post = computed(() => {
	return `https://www.linkedin.com/embed/feed/update/urn:li:share:${props.config.post_id}?collapsed=1`
})
</script>

<template>
	<iframe :src="post" height="671" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
</template>
